/* unplugin-vue-components disabled */import script from "./TabNav.vue?vue&type=script&setup=true&name=TabNav&lang=js"
export * from "./TabNav.vue?vue&type=script&setup=true&name=TabNav&lang=js"

import "./TabNav.vue?vue&type=style&index=0&id=1d39de44&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d39de44"]])

export default __exports__